/* ============================================================
   PRODUCT PERSONALIZER — CART ENHANCER (poster mode)
   ------------------------------------------------------------
   Agrega un botón "Ver mi imagen" a cada póster del carrito, que
   abre un modal con la vista previa. Empareja cada línea del
   carrito con su imagen usando el código (#XXXX) visible + las
   propiedades ocultas (_ref, _Vista Previa) leídas vía /cart.js.

   Instalar: subir a Assets y agregar antes de </body> en
   theme.liquid (o en el snippet del carrito):
     <script src="{{ 'product-personalizer-cart.js' | asset_url }}" defer></script>

   Funciona en página de carrito y cart drawer. Si NO se instala,
   el carrito igual se ve limpio (solo "Imagen personalizada: ... (#XXXX)").
   ============================================================ */
(function () {
  'use strict';

  var BTN_LABEL = 'Ver mi diseño';
  var MODAL_ID = '_pzp-cart-modal';
  var debounceTimer = null;

  // ---------- Modal (una sola instancia en el body) ----------
  function buildModal() {
    var m = document.getElementById(MODAL_ID);
    if (m) return m;
    m = document.createElement('div');
    m.id = MODAL_ID;
    m.style.cssText = 'display:none;position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483000;align-items:center;justify-content:center;';
    m.innerHTML =
      '<div data-ov style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.6);cursor:pointer;"></div>' +
      '<div data-box style="position:relative;background:#fff;border-radius:12px;padding:16px;max-width:92vw;max-height:88vh;display:flex;flex-direction:column;align-items:center;gap:12px;box-shadow:0 8px 32px rgba(0,0,0,.25);">' +
        '<button data-cl aria-label="Cerrar" style="position:absolute;top:6px;right:8px;background:none;border:none;cursor:pointer;font-size:26px;line-height:1;color:#777;padding:2px 6px;">&times;</button>' +
        '<img data-img alt="Vista previa de tu poster" style="max-width:100%;max-height:70vh;border-radius:8px;display:block;">' +
        '<button data-cl2 style="padding:10px 28px;background:#1a1a1a;color:#fff;border:none;border-radius:8px;font-weight:600;font-size:.9rem;cursor:pointer;">Cerrar</button>' +
      '</div>';
    document.body.appendChild(m);

    // Cerrar SOLO el modal — frenar la propagación para no cerrar el carrito (drawer)
    var close = function (e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      m.style.display = 'none';
    };
    m.querySelector('[data-ov]').addEventListener('click', close);
    m.querySelector('[data-cl]').addEventListener('click', close);
    m.querySelector('[data-cl2]').addEventListener('click', close);
    // Clicks dentro de la caja (imagen, etc.) no deben burbujear al carrito
    m.querySelector('[data-box]').addEventListener('click', function (e) { e.stopPropagation(); });
    return m;
  }

  function openModal(url) {
    var m = buildModal();
    m.querySelector('[data-img]').src = url;
    m.style.display = 'flex';
  }

  function makeButton(url) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = '_pzp-view-btn';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:5px;"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>' + BTN_LABEL;
    btn.style.cssText = 'display:inline-flex;align-items:center;margin-top:5px;padding:5px 12px;border:1px solid currentColor;border-radius:6px;background:none;color:inherit;cursor:pointer;font:inherit;font-size:.85em;font-weight:600;';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openModal(url);
    });
    return btn;
  }

  // ---------- Enganchar botones a cada póster del carrito ----------
  function enhance() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var map = {}; // ref -> previewUrl
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          var ref = null, url = null;
          Object.keys(p).forEach(function (k) {
            if (/(^|_)ref$/i.test(k)) ref = String(p[k]).replace(/[^A-Za-z0-9]/g, '');
            if (/vista\s*previa/i.test(k) && /^https?:/i.test(String(p[k]))) url = p[k];
          });
          if (ref && url) map[ref] = url;
        });

        var refs = Object.keys(map);
        if (!refs.length) return;

        refs.forEach(function (ref) {
          var url = map[ref];
          var marker = '(#' + ref + ')';
          var candidates = document.querySelectorAll('dd, span, div, p, li, td');
          for (var i = 0; i < candidates.length; i++) {
            var el = candidates[i];
            if (el.children.length !== 0) continue;
            if (!el.textContent || el.textContent.indexOf(marker) === -1) continue;
            // ¿Ya tiene el botón al lado? (evita duplicar en re-renders)
            var sib = el.nextElementSibling;
            if (sib && sib.classList && sib.classList.contains('_pzp-view-btn')) break;
            el.parentNode.insertBefore(makeButton(url), el.nextSibling);
            break; // un botón por póster
          }
        });
      })
      .catch(function () { /* silencioso */ });
  }

  function scheduleEnhance() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(enhance, 300);
  }

  function init() {
    enhance();
    if (window.MutationObserver) {
      var obs = new MutationObserver(scheduleEnhance);
      obs.observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('cart:refresh', scheduleEnhance);
    document.addEventListener('cart:updated', scheduleEnhance);
    document.addEventListener('cart:change', scheduleEnhance);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
